export const languages = ["en", "fr", "ar"];

export function parseLanguagePath(pathname) {
  const match = pathname.match(/^\/(fr|ar)(?=\/|$)/);
  const language = match ? match[1] : "en";
  const basename = match ? `/${language}` : "";
  return { language, basename, pathname: pathname.slice(basename.length).replace(/\/+$/, "") || "/" };
}

export function languagePath(pathname, language) {
  const { pathname: route } = parseLanguagePath(pathname);
  const prefix = language === "en" ? "" : `/${language}`;
  return `${prefix}${route === "/" ? "/" : `${route}/`}`;
}
